import React from "react"
import Page from "../../common/page/Page"
import { useAuth } from "../../data/useAuth"
// import { useSelector } from "react-redux"

const Dashboard = () => {
  const { user } = useAuth()
  // const dispatch = useDispatch()
  // const search = useSelector((state) => state.global.search)

  return (
    <>
      <Page title={"Dashboard"} is_admin={true}>
        <h2>
          Hi {user.first_name} {user.last_name}
        </h2>
      </Page>
    </>
  )
}

export default Dashboard
